<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-60">
      <div>
        <div class="entry_top">
          <p>入驻平台</p>
          <div class="entry_text" v-html="contenthtml">

          </div>
        </div>
        <div class="entry_middle">
          <p>智污邦平台会员权益</p>
          <moreTable class="pt-30 tec"></moreTable>

        </div>
        <div class="entry_bot">
          <div v-if="active"  class="bot_bar background1" @click.prevent="onSetitem()">立即入驻</div>
          <div v-else class="bot_bar background2" @click.prevent="onPromote()">立即升级</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {authlist,serverlist,getcrtinfolist} from '@/api/coment'
import commBanner from "../../common/commBanner";
import {getToken} from '@/utils/auth'
import titleHead from "../../common/titleHead";
import moreTable from "../../components/moreTable";
export default {
  components: { commBanner, titleHead, moreTable },
  data() {
    return {
      headTitle: "入驻平台",
      obj: {
        title: "入驻平台",
        isShow: false,
        isColor: false,
        bannerUrl:'',
        roleType:'',
        personalType:'',
      },
      contenthtml:'',
      data:[],//储存会员处理数据
      info:[],
      token:'',
      active:true
    };
  },
  created() {
    this.getcontenthtml();
    this.token = getToken();
    this.getMate();
    if(Object.keys(this.$store.state.user.userInfo != undefined &&
	  this.$store.state.user.userInfo).length !=0){
      this.active = false
    }
    if(this.$store.state.user.userInfo != null){
      this.obj.roleType = 9;
    }
  },
  methods: {
    getcontenthtml(){
      getcrtinfolist({name:'入驻平台说明'}).then((res)=>{
        if(res.code == 0){
           this.contenthtml=res.data[0].des;
        }
      })
    },
    //立即入驻
    onSetitem(){
      if(!this.token){
        this.$router.push('/register');
      }else{
        this.$router.push('/personal_information');
      }
    },
    //立即升级
    onPromote(){
      if(!this.token){
        this.$router.push('/register')
      }else{
        this.$router.push('/membership')
      }
    },
    getMate(){
        var metas = document.getElementsByTagName("meta");
        document.getElementsByTagName("title")[0].innerText= this.$route.meta.title +'_智污邦环保服务平台';
     },
  },
};
</script>
<style scoped>
.pt-30 {
  padding-top: 30px;
}
.mb-60 {
  margin-bottom: 60px;
}
.mt-20 {
  margin-top: 20px;
}
.tec {
  margin: 0 auto;
}
.entry_top {
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}
.entry_top p {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.entry_text {
  margin-top: 20px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #656565;
  line-height: 24px;
}
.entry_middle {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}
.entry_middle p {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  text-align: center;
}
.entry_bot {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.bot_bar {
  width: 214px;
  height: 50px;
  line-height: 50px;
  margin-right: 30px;
  cursor: pointer;
}
.background1 {
  background: linear-gradient(104deg, #d1e70d, #69cb1d);
}
.background2 {
  background: linear-gradient(104deg, #ff8101, #ffd101);
}
</style>



// WEBPACK FOOTER //
// src/view/other/platform_entry.vue